export const roles = {
  manager: 'ROLE_MANAGER',
  admin: 'ROLE_ADMIN'
}

export const phoneMask = '+7 (###)-###-##-##'
